import React from "react";
import { Dialog_VM, DialogFrame } from "./dialog-base";
import { StrucRow } from "../StructureElements/StrucRow";
import { StrucCol } from "../StructureElements/StrucCol";
import { InputWrapper } from "../Input/InputWrapper";
import { InputLabel } from "../Input/InputLabel";
import { CustomTextArea } from "../Input/CustomInput";
import {
  ApprovalGroup,
  ApprovalStatus,
} from "../../../core/models/entities/Approval";
import { Role } from "../../../core/models/entities/Role";
import { SecondaryButton } from "../Buttons/SecondaryButton";
import IconButton from "../LogoButton/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPenToSquare, faX } from "@fortawesome/free-solid-svg-icons";
import { BaseLogo } from "../../../core/models/entities/BaseLogo";

interface Props {
  approval?: ApprovalGroup;
  title: JSX.Element;
  dialogOptions: Dialog_VM;
  exclude: Role;
  onEdit?: () => void;
  onCancel?: () => void;
  isOrder?: boolean; // New prop to indicate if this is for an order
  logo?: BaseLogo; // Logo data to check for product SKU
}

export function RejectionNoteDialog({
  approval,
  title,
  dialogOptions,
  exclude,
  onEdit,
  onCancel,
  isOrder = false, // Default to false for backward compatibility
  logo, // Logo data to check for product SKU
}: Props) {
  return (
    <DialogFrame dialogOption={dialogOptions}>
      <div className={"space-y-4"}>
        <StrucRow>
          <StrucCol>{title}</StrucCol>
        </StrucRow>
        {approval?.vendor?.status === ApprovalStatus.Rejected && (
          <StrucRow>
            <StrucCol>
              <InputWrapper>
                <InputLabel>Vendor Note:</InputLabel>
                <CustomTextArea
                  readOnly={true}
                  value={approval.vendor?.rejectionNote ?? "no reason given"}
                />
              </InputWrapper>
            </StrucCol>
          </StrucRow>
        )}
        {approval?.customer?.status === ApprovalStatus.Rejected && (
          <StrucRow>
            <StrucCol>
              <InputWrapper>
                <InputLabel>Customer Note:</InputLabel>
                <CustomTextArea
                  readOnly={true}
                  value={approval.customer?.rejectionNote ?? "no reason given"}
                />
              </InputWrapper>
            </StrucCol>
          </StrucRow>
        )}
        {approval?.external?.status === ApprovalStatus.Rejected && (
          <StrucRow>
            <StrucCol>
              <InputWrapper>
                <InputLabel>External Customer Note:</InputLabel>
                <CustomTextArea
                  readOnly={true}
                  value={approval.external?.rejectionNote ?? "no reason given"}
                />
              </InputWrapper>
            </StrucCol>
          </StrucRow>
        )}
      </div>
      <div className="flex flex-row justify-between gap-3">
        <IconButton
          variant="dim"
          icon={<FontAwesomeIcon icon={faX} />}
          onClick={onCancel || dialogOptions.closeDialog}
          className="px-4"
        >
          Cancel
        </IconButton>
        {!isOrder && !logo?.productSku && !logo?.product?.sku && (
          <IconButton
            variant="success"
            icon={<FontAwesomeIcon icon={faPenToSquare} />}
            onClick={onEdit}
            key={"edit-logo"}
            className="px-4"
          >
            Edit
          </IconButton>
        )}
      </div>
    </DialogFrame>
  );
}
